import { useQuery } from '@tanstack/react-query';
import { getCapacity } from '../services/capacityService';

export function useCapacity() {
  return useQuery({
    queryKey: ['capacity'],
    queryFn: getCapacity,
    refetchInterval: 60000, // Refresh every 60s
  });
}
